import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function Truck({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Truck</title>
      <path
        d="M3 17V17.75C2.58579 17.75 2.25 17.4142 2.25 17H3ZM15 17H15.75C15.75 17.4142 15.4142 17.75 15 17.75V17ZM5 16.25C5.41421 16.25 5.75 16.5858 5.75 17C5.75 17.4142 5.41421 17.75 5 17.75V16.25ZM8 17.75C7.58579 17.75 7.25 17.4142 7.25 17C7.25 16.5858 7.58579 16.25 8 16.25V17.75ZM14 6.75H4V5.25H14V6.75ZM3.75 7V17H2.25V7H3.75ZM14.25 17V7H15.75V17H14.25ZM3 16.25H5V17.75H3V16.25ZM15 17.75H8V16.25H15V17.75ZM4 6.75C3.86193 6.75 3.75 6.86193 3.75 7H2.25C2.25 6.0335 3.0335 5.25 4 5.25V6.75ZM14 5.25C14.9665 5.25 15.75 6.0335 15.75 7H14.25C14.25 6.86193 14.1381 6.75 14 6.75V5.25Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M15 9.75C14.5858 9.75 14.25 9.41421 14.25 9C14.25 8.58579 14.5858 8.25 15 8.25V9.75ZM21 17H21.75C21.75 17.4142 21.4142 17.75 21 17.75V17ZM19 17.75C18.5858 17.75 18.25 17.4142 18.25 17C18.25 16.5858 18.5858 16.25 19 16.25V17.75ZM17.5858 9.75H15V8.25H17.5858V9.75ZM18.8232 8.76256L21.2374 11.1768L20.1768 12.2374L17.7626 9.82322L18.8232 8.76256ZM20.25 17V12.4142H21.75V17H20.25ZM19 16.25H21V17.75H19V16.25ZM21.2374 11.1768C21.5656 11.505 21.75 11.9501 21.75 12.4142H20.25C20.25 12.3479 20.2237 12.2843 20.1768 12.2374L21.2374 11.1768ZM17.5858 8.25C18.0499 8.25 18.495 8.43437 18.8232 8.76256L17.7626 9.82322C17.7157 9.77634 17.6521 9.75 17.5858 9.75V8.25Z"
        fill={color ?? 'currentColor'}
      />
      <circle
        r="1.5"
        transform="matrix(-1 0 0 1 6.5 17.5)"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        r="1.5"
        transform="matrix(-1 0 0 1 17.5 17.5)"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
